import clsx from "clsx";
import blendStyles from "../WordBlendFlow.module.css";
import styles from "./ClusterSpreadCvc.module.css";

export { deriveClusterInteractiveTapSteps } from "./tapSteps";
export { InteractiveTapStepRow } from "./InteractiveTapStepRow";

export function ClusterSpreadCvcBuiltLine({ text }) {
  const safe = typeof text === "string" ? text : "";
  return (
    <div
      className={clsx(blendStyles.builtRow, styles.builtLineEnhance)}
      role="status"
      aria-live="polite"
      aria-label={
        safe ? `Built so far: ${safe}` : "Completed letters appear here after each Next"
      }
    >
      {safe || "\u00a0"}
    </div>
  );
}
